











export const OPS = ['+', '−', '×', '÷'] as const;

export const isOp = (c: string | undefined) => !!c && (OPS as readonly string[]).includes(c);

export function evaluate(expr: string): number | null {
  const tokens = expr.match(/\d+(?:,\d*)?|[+−×÷]/g);
  if (!tokens) return null;
  if (isOp(tokens[tokens.length - 1])) tokens.pop();
  if (!tokens.length || isOp(tokens[0])) return null;
  const terms: number[] = [];
  let sign = 1;
  let term = Number(tokens[0].replace(',', '.'));
  for (let i = 1; i < tokens.length; i += 2) {
    const op = tokens[i];
    const n = Number(tokens[i + 1].replace(',', '.'));
    if (op === '×') term *= n;
    else if (op === '÷') term = n === 0 ? NaN : term / n;
    else { terms.push(sign * term); sign = op === '+' ? 1 : -1; term = n; }
  }
  terms.push(sign * term);
  const v = Math.round(terms.reduce((a, b) => a + b, 0) * 100) / 100;
  return Number.isFinite(v) ? v : null;
}

export const hasOp = (expr: string) => /[+−×÷]/.test(expr.replace(/^[+−×÷]/, ''));

export function formatExpr(expr: string) {
  return expr.replace(/\d+/g, (d, offset: number) => (expr[offset - 1] === ',' ? d : d.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')))
    .replace(/([+−×÷])/g, ' $1 ');
}

export const exprOf = (n: number | null | undefined) => (n ? String(Math.round(Math.abs(n) * 100) / 100).replace('.', ',') : '');

export const normalizeTyped = (s: string) => s.replace(/\s/g, '').replace(/\./g, ',').replace(/\*/g, '×').replace(/\//g, '÷').replace(/-/g, '−').replace(/[^\d,+−×÷]/g, '');
